import { Component, Input, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ContactContainer } from 'src/app/interfaces/contact-container';
import { CNConsultation } from 'src/app/models/cnconsultation';

@ManageType('ContactContentOphtalmoComponent')
@Component({
  selector: 'app-contact-content-ophtalmo',
  templateUrl: './contact-content-ophtalmo.component.html',
  styleUrls: ['./contact-content-ophtalmo.component.scss']
})
export class ContactContentOphtalmoComponent implements OnInit, ContactContainer {

  private contentContact: CNConsultation;

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * ContactContainer interface
   */

  @Input() set contact(theContact: CNConsultation) {
    this.contentContact = theContact;
    console.log('contact', this.contentContact);
  }

  get contact(): CNConsultation {
    return this.contentContact;
  }
}
